import React, {useContext, useEffect, useState} from "react";
import {Button, Card, CardActions, CardContent, ClickAwayListener, IconButton, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import {CLIENT_URL, FetchContext} from "../../context/FetchContext";
import {AuthContext} from "../../context/AuthContext";
import {RefreshTokenAndRetry} from "../../utils/utils";


const ShareCard = ({ onClose, currentProjectId }) => {

    const [linkCopied, setLinkCopied] = useState(false);

    const fetchContext = useContext(FetchContext);
    const authContext = useContext(AuthContext);

    const [token, setToken] = useState('');

    const projectShareUrl = ({projectId, token}) => {
        return CLIENT_URL + "/shared/projects/" + projectId + "/" + token;
    }

    const [shareLink, setShareLink] = useState(projectShareUrl({projectId: currentProjectId, token: token}));

    useEffect(() => {
        const getProjectToken = async () => {
            try {
                const response = await fetchContext.authAxios.get(`/share/project/${currentProjectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    },
                });
                setToken(response.data.token);
                setShareLink(projectShareUrl({projectId: currentProjectId, token: response.data.token}));
            } catch (error) {
                if (error.response.status === 401) {
                    await RefreshTokenAndRetry(error, authContext, fetchContext);
                }
            }
        }

        getProjectToken();

    }, [currentProjectId]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareLink);
        setLinkCopied(true);
    };

    const copyButtonText = linkCopied ? 'Copied!' : 'Copy';

    return (
        <ClickAwayListener onClickAway={onClose}>
        <Card
            elevation={5}
            style={{ cursor: 'pointer', position: 'absolute',
                top: 65,
                right: 75,
                maxWidth: 480,
                backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark background
                borderRadius: '16px', // Rounded corners
                boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
                overflow: 'visible',
                height: 190,
                zIndex: 1000,
            }}
        >
            <CardContent>
                <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }} variant="contained">
                    <CloseIcon style={{fontSize: "1.0rem", color: "white"}}/>
                </IconButton>
                <Typography variant="h6" marginBottom={1} color="white" fontWeight={700}>
                    Share project
                </Typography>
                <Typography variant="subtitle2" color="text.secondary" fontSize="1.0rem">
                    Share access to this project's recordings. Anyone with the link can preview and download all recordings and uploaded files.
                </Typography>
            </CardContent>
            <CardActions style={{ marginTop: '-10px', paddingLeft: '12px', justifyContent: 'space-between'}}>
                <TextField
                    variant="outlined"
                    size="small"
                    value={shareLink}
                    InputProps={{
                        readOnly: true,
                        style: { backgroundColor: 'rgba(0, 0, 0, 0.8)', color: 'white', width: '370px' }, // Adjust text color if needed
                    }}
                    style={{ borderRadius: '7px' }}
                />
                <Button
                    variant="contained"
                    onClick={copyToClipboard}
                    style={{ height: '40px', width: '80px', borderRadius: '10px' }} // Adjust button colors as needed
                >
                    <Typography fontWeight={600}>
                        {copyButtonText}
                    </Typography>
                </Button>
            </CardActions>
        </Card>
        </ClickAwayListener>
    );
};

export default ShareCard;
